import Vue from 'vue'
import app from './App'

new Vue(app)
  .$mount('#app');



// WEBPACK FOOTER //
// ./docs/main.js